<ng-template #validateOtpBody>
  <app-otp-verification-block
    [maskedDestination]="otpData.maskedDestination"
    [otpLength]="5"
    [expiresInSeconds]="otpData.expiresInSeconds"
    [errorMessage]="validateError"
    [validating]="validating"
    [showResendLink]="false"
    [submitLabel]="'Continuar'"
    [hintText]="'Código de 5 dígitos que recibió por ' + (otpData.channel === 'email' ? 'correo' : 'celular')"
    [expiredMessage]="'El código ha expirado. Debe solicitar uno nuevo desde el paso anterior.'"
    (submitCode)="onSubmit($event)"
    (cancel)="closeDialog()"
  ></app-otp-verification-block>
</ng-template>

<div *ngIf="!embedded" mat-dialog-content role="dialog" aria-modal="true">
  <ng-container *ngTemplateOutlet="validateOtpBody"></ng-container>
</div>
<div *ngIf="embedded" class="tf-admin-step-panel tf-validate-otp-embedded" role="region">
  <ng-container *ngTemplateOutlet="validateOtpBody"></ng-container>
</div>
